<template>
    <div>
        <form method="POST" action="/admin/statistics/bookkeeping/excel">
            <input type="hidden" name="_token" :value="csrf_token">
            <div class="row">
                <div class="col-md-9">
                    <h3>Укажите даты начала и конца отчетного периода:</h3>
                    <date-range-picker></date-range-picker>
                    <div class="clearfix"></div>
                </div>
                <div class="col-md-3">
                    <div class="form-group">
                        <button class="btn btn-primary form-control" @click="load">
                            <span v-show="!show_loader">Показать отчет</span>
                            <i v-show="show_loader" class="fa fa-spinner fa-spin" style="font-size:24px"></i>
                        </button>
                    </div>
                    <!--<div class="form-group">
                        <button type="submit" class="btn btn-success form-control">
                            <i class="fa fa-file-excel-o"></i>
                            Выгрузить в Excel
                        </button>
                    </div>-->
                </div>
            </div>
        </form>
        <div class="row" style="margin-top:50px;">
            <div class="col-md-4 col-xs-12">
                <div class="box box-solid box-primary" v-show="warehouse_prices.purchasePriceEuro !== ''">
                    <div class="box-header">
                        <h3 class="box-title">На складе товаров на сумму:</h3>
                    </div>
                    <div class="box-body">
                        <h2 class="text-center">
                            <span v-if="warehouse_prices.purchasePriceEuro !== '0'">
                                <strong>Товары - {{warehouse_prices.purchasePriceEuro}} &#8364;</strong><br/>
                                <strong>({{warehouse_prices.purchasePriceRub}} &#8381;)</strong><br/>
                                <strong>Бонусы - {{warehouse_prices.bonusesPurchasePrice}} &#8364;</strong><br/>
                            </span>
                            <span v-else>
                                <strong>нет данных</strong>
                            </span>
                        </h2>
                    </div>
                    <div class="box-footer">
                        <p class="text-muted">
                            Цена закупочная. <br>
                            Данные на конец отчетного периода. <br>
                            <strong>Учитывается только доступный товар на складе.</strong> <br>
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-md-4 col-xs-12">
                <div class="box box-solid box-default" v-show="in_delivery_price">
                    <div class="box-header">
                        <h3 class="box-title">В пути товаров на сумму:</h3>
                    </div>
                    <div class="box-body">
                        <h2 class="text-center">
                            <strong v-if="in_delivery_price !== '0'">{{in_delivery_price}} &#8364;</strong>
                            <strong v-else>нет данных</strong>
                        </h2>
                    </div>
                    <div class="box-footer">
                        <p class="text-muted">
                            Цена закупочная. <br>
                            Данные на конец отчетного периода. <br>
                            Учитываются упаковки: <br>
                                - в заказах по предоплате, находящихся в статусе "Оплачивается"; <br>
                                - в заказах по наложенному платежу, не дошедших до статуса "Готов". <br>
                            <strong>Бонусы не учитываются!</strong> <br>
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-md-4 col-xs-12">
                <div class="box box-solid box-danger" v-show="spent_price">
                    <div class="box-header">
                        <h3 class="box-title">Закупочная стоимость проданных товаров:</h3>
                    </div>
                    <div class="box-body">
                        <h2 class="text-center"><strong>{{spent_price}} &#8364;</strong></h2>
                    </div>
                    <div class="box-footer">
                        <p class="text-muted">
                            За отчетный период.
                        </p>
                    </div>
                </div>
                <div class="box box-solid box-success" v-show="profit">
                    <div class="box-header">
                        <h3 class="box-title">Получено от продажи:</h3>
                    </div>
                    <div class="box-body">
                        <h2 class="text-center"><strong>{{profit}} &#x20bd;</strong></h2>
                    </div>
                    <div class="box-footer">
                        <p class="text-muted">
                            За отчетный период.
                        </p>
                        <div class="form-group">
                            <form method="POST" action="/admin/statistics/bookkeeping/profit/excel">
                                <input type="hidden" name="_token" :value="csrf_token">
                                <input type="hidden" name="date_start" :value="date_start">
                                <input type="hidden" name="date_finish" :value="date_finish">
                                <button type="submit" class="btn btn-success" style="margin-top: 5px;">
                                    <i class="fa fa-file"></i>
                                    <span>Выгрузить в excel</span>
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: [],
    mounted: function() {
        Vue.http.headers.common['X-CSRF-TOKEN'] = document.querySelector('#token').getAttribute('content');
        this.csrf_token = document.querySelector('#token').getAttribute('content');
    },
    data: function () {
        return {
            csrf_token: '',
            show_loader: false,
            date_start: '',
            date_finish: '',
            warehouse_prices: {
                purchasePriceEuro: '',
                purchasePriceRub: '',
                bonusesPurchasePrice: ''
            },
            in_delivery_price: '',
            spent_price: '',
            profit: ''
        };
    },
    methods: {
        load: function (event) {
            event.stopPropagation();
            event.preventDefault();
            if (!this.checkEnteredData()) {
                alert('Заполните обязательные поля!');
                return;
            }
            this.show_loader = true;

            this.$http.post(
                '/statistics/bookkeeping/get',
                {
                    date_start: this.date_start,
                    date_finish: this.date_finish
                }
            ).then(function (response) {
                this.show_loader = false;
                if(response.data.warehouse_prices.length !== 0) {
                    this.warehouse_prices = response.data.warehouse_prices;
                } else {
                    this.warehouse_prices = {
                        purchasePriceEuro: '0',
                        purchasePriceRub: '0',
                        bonusesPurchasePrice: '0'
                    };
                }

                this.in_delivery_price = response.data.in_delivery_price;
                this.spent_price = response.data.spent_price;
                this.profit = response.data.profit;
            }, function (response) {
                this.show_loader = false;

                let errors = '';
                for (let field in response.data) {
                    errors += response.data[field] + '\r\n';
                }

                alert(errors);
            });
        },
        checkEnteredData: function () {
            return !!(
                this.date_start && this.date_finish
            );
        }
    },
    created: function () {
        this.$root.$on('update:date_range', (val) => { this.date_start = val.date_start; this.date_finish = val.date_finish; });
    }
};
</script>
